import React from "react"
import PropTypes from "prop-types"
import {
  CardHeader,
  CardContent,
  CardFooter,
  CardTitle,
  CardDescription,
  Button,
} from "ksc-portal-common-components/shadcn"
import connector from "../../../utils/reduxRouter/connector"

export const CheckEmailComponent = ({
  backToLogin,
  match: {
    params: { username },
  },
}) => (
  <>
    <CardHeader className="flex flex-col items-center">
      <svg
        width="68"
        height="62"
        viewBox="0 0 68 62"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Illustrations">
          <path
            id="Vector (Stroke)"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.13012 7.88103C8.22049 7.88103 7.48309 8.63256 7.48309 9.55961V10.2332L28.1052 23.5884C28.3422 23.7381 28.6156 23.8174 28.8945 23.8174C29.1735 23.8174 29.4468 23.7381 29.6839 23.5884L50.306 10.2332V9.55961C50.306 8.63256 49.5686 7.88103 48.6589 7.88103H9.13012ZM56.8941 12.0209V9.55961C56.8941 4.92436 53.2071 1.16675 48.6589 1.16675H9.13012C4.58196 1.16675 0.894949 4.92436 0.894949 9.55961V12.0208C0.894392 12.0565 0.894392 12.0921 0.894949 12.1278V39.7739C0.894949 44.4091 4.58196 48.1667 9.13012 48.1667H48.6589C53.2071 48.1667 56.8941 44.4091 56.8941 39.7739V12.1277C56.8947 12.0921 56.8947 12.0565 56.8941 12.0209ZM50.306 18.1884L33.1881 29.2742C31.9012 30.0959 30.4132 30.5317 28.8945 30.5317C27.3759 30.5317 25.8879 30.0959 24.601 29.2742L24.5831 29.2628L7.48309 18.1884V39.7739C7.48309 40.7009 8.22049 41.4525 9.13012 41.4525H48.6589C49.5686 41.4525 50.306 40.7009 50.306 39.7739V18.1884Z"
            fill="#D1D5DB"
            stroke="#9BA3AF"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle
            id="Ellipse 85"
            cx="49.1055"
            cy="42.8334"
            r="18"
            fill="#D1D5DB"
            stroke="#9BA3AF"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle
            id="Ellipse 84"
            cx="49"
            cy="43"
            r="13"
            fill="#F7FAFB"
            stroke="#9BA3AF"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector (Stroke)_2"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M55.0779 38.2329C55.4095 38.5521 55.4196 39.0796 55.1004 39.4112L47.0796 47.7446C46.9225 47.9078 46.7057 48 46.4792 48C46.2526 48 46.0359 47.9078 45.8788 47.7446L42.2329 43.9567C41.9138 43.6251 41.9238 43.0975 42.2554 42.7784C42.587 42.4592 43.1146 42.4693 43.4337 42.8009L46.4792 45.965L53.8996 38.2554C54.2188 37.9238 54.7463 37.9138 55.0779 38.2329Z"
            fill="#9390E9"
            stroke="#9390E9"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </svg>
    </CardHeader>
    <CardContent>
      <div className="space-y-2 flex flex-col items-center">
        <CardTitle className="text-center text-2xl font-medium text-foreground">
          We&apos;ve sent you a reset email!
        </CardTitle>
        <CardDescription className="text-center text-sm text-muted-foreground ">
          We sent an email to <b>{username}</b>, follow the instructions on the
          email to complete the process.
        </CardDescription>
      </div>
    </CardContent>
    <CardFooter className="flex justify-center">
      <Button variant="default" onClick={backToLogin} className="w-full">
        Back to Login
      </Button>
    </CardFooter>
  </>
)

CheckEmailComponent.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      username: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  backToLogin: PropTypes.func.isRequired,
}

export default connector({
  mapState: () => ({}),
  mapDispatch: () => ({}),
  component: CheckEmailComponent,
})
